/**
 * Окно входа соцсети (Instagram, TikTok, Threads) — 28.10.2026.
 *
 * Окно открывается под постоянным именем, и если от прошлой попытки осталось
 * спрятанное окно с тем же именем, браузер переиспользует его, не показывая.
 * Снаружи это выглядит как «окно не открылось»: кнопка крутится, окна нет.
 * Поэтому окно сразу выводится вперёд, а страница может показать его ещё раз
 * или закрыть — тогда вход обрывается как при обычном закрытии окна.
 */

const FEATURES = 'width=600,height=700,scrollbars=yes,resizable=yes';

let current: Window | null = null;

/** null — браузер заблокировал окно. */
export function openLoginPopup(url: string, name: string): Window | null {
  const popup = window.open(url, name, FEATURES);
  if (!popup) return null;
  popup.focus();
  current = popup;
  return popup;
}

export function focusLoginPopup(): void {
  if (current && !current.closed) current.focus();
}

export function closeLoginPopup(): void {
  if (current && !current.closed) current.close();
}
